import api from 'lib/api';

// Types
const LOAD_SUCCESS = 'video/LOAD_RELATED_SUCCESS';
const LOAD_PENDING = 'video/LOAD_RELATED_PENDING';
const LOAD_ERROR = 'video/LOAD_RELATED_ERROR';

// Actions
export const loadRelatedVideo = (id) => api({
  endpoint: `video/${id}`,
  types: [LOAD_PENDING, LOAD_SUCCESS, LOAD_ERROR],
  bentoApi: true,
});

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  let data;
  if (action.payload) {
    ({ data } = action.payload);
  }
  switch (action.type) {
    case LOAD_SUCCESS:
      return {
        headline: (data.video && data.video.headline) || {},
        description: (data.video && data.video.description) || {},
        ecommerceEnabled: false,
        url: (data.video && data.video.url && data.video.url.primary) || '',
      };

    default:
      return state;
  }
};
